/** @format */
import React from 'react';

export const displayAsPrice = (text) => {
  if (typeof text === 'number') {
    text = text.toString();
  }

  if (typeof text === 'string') {
    const cleanedText = text.replace(/[\s,]/g, '');

    const formattedText = cleanedText.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');

    return formattedText;
  }

  return '';
};

export const displayTextInParagraphs = (text) => {
  if (typeof text === 'string') {
    const paragraphs = text.split(/(?<=[.!?])\s+/);
    return paragraphs.map((paragraph, index) => (
      <p key={index} className='text2r'>
        {paragraph}
      </p>
    ));
  }

  return text;
};
